import React from 'react'
import { Modal } from 'antd'

export default function ConfirmationModal(props) {
    return (
        <Modal
            centered
            open={props.isOpen}
            onOk={props.onOk}
            onCancel={props.onCancel}
            closable={props.closable}
            width={props.width}
            className={props.className}
            okText={props.okText}
            cancelText={props.cancelText}
        >
            <div className="flex flex-col justify-center items-center">
                <h2 className="font-roboto text-3xl font-bold mb-[16px]">{props.title}</h2>
                <p className="font-roboto text-base text-[#666666] text-center mb-[16px]">{props.description}</p>
            </div>
        </Modal>
    )
}
